import React, { useState } from "react";
import { FaPen } from "react-icons/fa";
import RichTextView from "./RichTextView";
import RichTextEditor from "./RichTextEditor";
import { useDirtyDraft } from "./nestedOverlay";

// Açıklama: görüntüleme (RichTextView) / düzenleme (RichTextEditor + Kaydet/Vazgeç).
// Düzenlerken taslak yerel state'te tutulur; arka planda gelen güncel iş onu ezmez.
const MAX_DESCRIPTION = 100 * 1024;

function TaskDescription({ html, canEdit, resolveImage, onUploadImage, onSave }) {
  const [draft, setDraft] = useState(null); // null = görüntüleme
  const [saving, setSaving] = useState(false);
  const editing = draft !== null;
  const tooLong = editing && draft.length > MAX_DESCRIPTION;
  useDirtyDraft(editing && draft !== (html || ""));

  const save = async () => {
    if (tooLong) return;
    if ((draft || "") === (html || "")) return setDraft(null);
    setSaving(true);
    const ok = await onSave(draft || "");
    setSaving(false);
    if (ok) setDraft(null);
  };

  return (
    <section>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-SemiBold text-gray-700">Açıklama</h3>
        {canEdit && !editing && (
          <button
            type="button"
            onClick={() => setDraft(html || "")}
            className="inline-flex items-center gap-1 text-xs font-Medium text-gray-500 hover:text-main"
          >
            <FaPen className="w-3 h-3" aria-hidden="true" />
            Düzenle
          </button>
        )}
      </div>
      {editing ? (
        <div className="space-y-2">
          <RichTextEditor
            value={draft}
            onChange={setDraft}
            onUploadImage={onUploadImage}
            resolveImage={resolveImage}
            placeholder="Açıklama yazın..."
          />
          {tooLong && <p className="text-xs text-fifth">Açıklama en fazla 100 KB olabilir.</p>}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setDraft(null)}
              disabled={saving}
              className="px-3 py-1.5 rounded-lg text-sm font-Medium text-gray-600 hover:bg-gray-100 disabled:opacity-50"
            >
              Vazgeç
            </button>
            <button
              type="button"
              onClick={save}
              disabled={saving || tooLong}
              className="px-3 py-1.5 rounded-lg text-sm font-Medium bg-main text-white hover:opacity-90 disabled:opacity-50"
            >
              {saving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </div>
      ) : html ? (
        <RichTextView html={html} resolveImage={resolveImage} />
      ) : (
        <p className="text-sm text-gray-400">Açıklama yok.</p>
      )}
    </section>
  );
}

export default TaskDescription;
